import { render } from "./decline-form.vue?vue&type=template&id=139322be&scoped=true"
import script from "./decline-form.vue?vue&type=script&lang=js"
export * from "./decline-form.vue?vue&type=script&lang=js"

import "./decline-form.vue?vue&type=style&index=0&id=139322be&lang=scss&scoped=true"

import exportComponent from "/home/node/ks-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-139322be"]])

export default __exports__